let ID_COUNTER = 1

// eslint-disable-next-line no-plusplus
const nextId = () => ID_COUNTER++

export default nextId
